import { FC } from "react";
//#region redux
import { useDispatch } from "react-redux";
import { displayDialog } from "store/actions/utilActions";
//#endregion
//#region types
import { ACTION_SEPARATOR } from "models/propTypes/menuPropTypes";
import { TranslationKeys } from "translations";
import { BenefitFormTypes } from "models/formTypes";
//#endregion
//#region components
import { useDeviationPermissions } from "components/salaryDeviation";
import { DashboardButtonGroup, FilterButton, PageLayouts, ReloadEvent, StyledButton } from "components/common";
import { Grid } from "@mui/material";
import useBenefitReportFilterDefinition from "./useReportFilterDefinition";
import useBenefitDialog from "./forms/useBenefitDialog";
import BenefitList from "./benefitList";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

const BenefitReport: FC = () => {
  const dispatch = useDispatch();
  const { filterFormFields, filterQueryStateHandler } = useBenefitReportFilterDefinition();
  const { isSalaryAdmin } = useDeviationPermissions();
  const { getBenefitCreationDialog } = useBenefitDialog();
  const onCreateBenefitClick = (onSubmitSuccess?: () => void) => {
    dispatch(displayDialog(getBenefitCreationDialog(onSubmitSuccess)));
  };

  const getTopRightButtons = (reload: () => void) => {
    let buttons: (React.ReactElement | typeof ACTION_SEPARATOR)[] = [];

    if (isSalaryAdmin) {
      buttons = [
        ...buttons,
        <StyledButton size="sm" onClick={onCreateBenefitClick.bind(null, reload)}>
          {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Benefit.AddBenefit)}
        </StyledButton>,
        ACTION_SEPARATOR,
      ];
    }

    buttons = [...buttons, <FilterButton />];

    return buttons;
  };

  return (
    <ReloadEvent
      render={(reloadKey, reload) => (
        <PageLayouts.DashboardLayout<BenefitFormTypes.Filter>
          entityKey={0}
          title={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Benefit.BenefitsTitle)}
          topRightButtons={<DashboardButtonGroup buttons={getTopRightButtons(reload)} />}
          filterFields={filterFormFields}
          filterQueryStateHandler={filterQueryStateHandler}
          initialFilter={{
            monthRange: {
              start: new Date(),
              end: new Date(),
            },
          }}
        >
          <Grid container item>
            <BenefitList reloadKey={reloadKey} reloadList={reload} />
          </Grid>
        </PageLayouts.DashboardLayout>
      )}
    />
  );
};

export default BenefitReport;
